<script>
import VPmNoteForm from "@/components/Forms/VPmNoteForm";
import PmNoteService from "@/services/PmNoteService";
import { EventBus } from "@/libraries/EventBus";
import VControl from "@/components/Planning/Helpers/VControl";
import VFilters from "@/components/Search/VFilters";
import ProjectService from "@/services/ProjectService";
import { mapGetters } from "vuex";
import VInlineEdit from "./VInlineEdit.vue";

export default {
    props: {
        project_id: {}
    },
    components: { VFilters, VPmNoteForm, VControl, VInlineEdit },
    data() {
        return {
            loading: true,
            items: [],
            context: { empty: true },
            showModal: false,
            selectedFilter: "all",
            meta: {},
            showSection: false,
            project: {},
            suSaving: false,
            suError: ""
        };
    },
    computed: {
        ...mapGetters("auth", ["getMyId"])
    },
    async created() {
        await this.fetchProject();
        if (parseInt(this.project.user_id) === parseInt(this.getMyId)) {
            this.ACL_RW = true;
        } else {
            this.ACL_RW = false;
        }

        this.resetSearch();
        this.$apiEnableWatcher();
        this.loading = true;

        await this.fetchData();
        this.loading = false;
        EventBus.$on("journal-refresh", this.fetchData);
        EventBus.$on("data-tab-open", () => {
            this.showSection = true;
        });
        EventBus.$on("data-tab-close", () => {
            this.showSection = false;
        });

        if (this.items.length > 0) {
            this.showSection = true;
        }
    },
    beforeDestroy() {
        EventBus.$off("journal-refresh", this.fetchData);
        EventBus.$off("data-tab-open");
        EventBus.$off("data-tab-close");
    },
    methods: {
        resetSearch() {
            this.apiSearchFilter = {
                search: ""
            };

            this.apiPaginator.sort = "created";
            this.apiPaginator.direction = "desc";
        },
        async fetchProject() {
            try {
                const r = await ProjectService.GETS(this.project_id);
                this.project = r.data.data;
            } catch (e) {
                console.log("fetchProject exception", e);
            }
        },
        async fetchData() {
            try {
                let params = this.$buildParams();
                params["project_id"] = this.project_id;

                if (this.selectedFilter == "latestMonth") {
                    params["dateFilter"] = "latestMonth";
                }

                const { data } = await PmNoteService.GET(params);
                this.items = data.data;
                this.meta = data.meta;
            } catch (e) {
                console.log("fd e", e);
            }
        },
        async updateText(item, new_text) {
            try {
                this.suSaving = true;
                this.suError = "";
                const data = {
                    id: item.id,
                    description: new_text
                };

                await PmNoteService.PUT(data);
                await this.fetchData();
            } catch (e) {
                console.log("E updateText", e);
                this.suError = e.response.data.errors;
            }

            this.suSaving = false;
        },
        async closeReload() {
            this.showModal = false;
            this.fetchData();
        },
        setContext(ctx) {
            this.context = ctx;
            this.showModal = true;
        },
        filter(orderCmd) {
            this.selectedFilter = orderCmd;
            this.fetchData();
        }
    }
};
</script>

<template>
    <div class="v-pm-notes">
        <div class="container-fluid">
            <div class="row card-wrapper">
                <div class="col-12">
                    <div class="mb-3">
                        <v-control
                            :show="showSection"
                            @trigger="showSection = !showSection"
                        >
                            <h3 class="pb-0 mb-0">
                                {{ $t("pm_notes.pm_notes") }}
                            </h3>
                        </v-control>
                    </div>

                    <template v-if="showSection">
                        <v-loader :loading="loading" v-if="loading" />
                        <card body-classes="px-0" v-else>
                            <div
                                class="mx-4 mb-3 d-flex justify-content-between"
                            >
                                <div>
                                    <v-filters
                                        :search="true"
                                        :enable-filters="false"
                                        :start-open="true"
                                        v-model="apiSearchFilter.search"
                                        @reset-search="resetSearch"
                                    ></v-filters>
                                </div>
                                <div>
                                    <base-button
                                        size="sm"
                                        :type="
                                            selectedFilter == 'latestMonth'
                                                ? 'primary'
                                                : 'secondary'
                                        "
                                        @click="filter('latestMonth')"
                                        >{{
                                            $t("pm_notes.filter_month")
                                        }}</base-button
                                    >
                                    <base-button
                                        size="sm"
                                        :type="
                                            selectedFilter == 'all'
                                                ? 'primary'
                                                : 'secondary'
                                        "
                                        @click="filter('all')"
                                        >{{
                                            $t("pm_notes.filter_all")
                                        }}</base-button
                                    >
                                </div>
                            </div>

                            <div v-if="items.length > 0">
                                <v-table class="table table-mg table-sm">
                                    <v-thead>
                                        <v-tr>
                                            <v-th class="hdr__id"
                                                ><v-sorter
                                                    v-if="false"
                                                    :paginator="apiPaginator"
                                                    name="id"
                                                    @sort="
                                                        $handleSorting($event)
                                                    "
                                                    >{{
                                                        $t("pm_notes.hdr_id")
                                                    }}</v-sorter
                                                ></v-th
                                            >
                                            <v-th class="hdr__date"
                                                ><v-sorter
                                                    :paginator="apiPaginator"
                                                    name="created"
                                                    @sort="
                                                        $handleSorting($event)
                                                    "
                                                    >{{
                                                        $t("pm_notes.hdr_date")
                                                    }}</v-sorter
                                                ></v-th
                                            >
                                            <v-th style="width: 75%"
                                                ><v-sorter
                                                    :paginator="apiPaginator"
                                                    name="description"
                                                    @sort="
                                                        $handleSorting($event)
                                                    "
                                                    >{{
                                                        $t("pm_notes.hdr_note")
                                                    }}</v-sorter
                                                ></v-th
                                            >
                                            <v-th></v-th>
                                        </v-tr>
                                    </v-thead>
                                    <v-tbody>
                                        <v-tr
                                            v-for="item in items"
                                            :key="item.id"
                                        >
                                            <v-td v-if="false">
                                                {{ item.project_id }}-PM-{{
                                                    item.id
                                                }}
                                            </v-td>
                                            <v-td>
                                                {{
                                                    $d(
                                                        new Date(item.created),
                                                        "short"
                                                    )
                                                }}
                                            </v-td>
                                            <v-td class="preserve-newlines">
                                                <v-inline-edit
                                                    :text="item.description"
                                                    @save="
                                                        updateText(item, $event)
                                                    "
                                                    :saving="suSaving"
                                                    :error="suError"
                                                />
                                            </v-td>
                                            <v-td
                                                class="text-right"
                                                v-if="ACL_RW"
                                            >
                                                <i
                                                    class="far fa-fw fa-lg fa-pencil m-click"
                                                    @click="setContext(item)"
                                                ></i>
                                            </v-td>
                                        </v-tr>
                                    </v-tbody>
                                </v-table>

                                <div
                                    class="paginator"
                                    v-if="meta.pagination.total_pages > 1"
                                >
                                    <base-pagination
                                        :page-count="
                                            meta.pagination.total_pages
                                        "
                                        :per-page="meta.pagination.per_page"
                                        :value="meta.pagination.current_page"
                                        @input="$handlePagination($event)"
                                    />
                                </div>
                            </div>
                            <div class="mx-4 alert alert-warning" v-else>
                                {{ $t("pm_notes.no_items") }}
                            </div>
                            <base-button
                                type="link"
                                class="mt-3 mx-3"
                                size="sm"
                                @click="setContext({ empty: true })"
                                ><i class="far fa-plus"></i>
                                {{ $t("pm_notes.add_new") }}</base-button
                            >
                        </card>
                    </template>
                </div>
            </div>
        </div>

        <portal to="modals">
            <v-pm-note-form
                :context="context"
                @close="showModal = false"
                @close-reload="closeReload"
                :project-id="project_id"
                v-if="showModal"
            />
        </portal>
    </div>
</template>

<style scoped>
.preserve-newlines {
    white-space: pre-line;
    width: 100%;
}
</style>

<style lang="scss">
.v-pm-notes {
    .hdr__id {
        width: 140px;
    }

    .hdr__date {
        width: 110px;
    }
}
</style>
